import { render } from "./PaginationUI.vue?vue&type=template&id=358a5e30"
import script from "./PaginationUI.vue?vue&type=script&lang=js"
export * from "./PaginationUI.vue?vue&type=script&lang=js"

import "./PaginationUI.vue?vue&type=style&index=0&id=358a5e30&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__